export default "__VITE_ASSET__Bm0z72On__"